var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('TheHeader'),_c('main',{staticClass:"content"},[_c('h1',{staticClass:"visually-hidden"},[_vm._v("Личный сайт веб-разработчика JedenCode")]),_c('router-view')],1),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }